// @generated by protoc-gen-es v1.10.0
// @generated from file omnios/v1/manufacturing.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Struct, Timestamp } from "@bufbuild/protobuf";
import { PageRequest, PageResponse } from "./common_pb.js";

/**
 * @generated from message omnios.v1.DemandSignal
 */
export const DemandSignal = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DemandSignal",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "warehouse_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "qty", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "uom", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "need_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "probability", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 8, name: "priority", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "source_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "constraints", kind: "message", T: Struct },
    { no: 13, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 30, name: "created_at", kind: "message", T: Timestamp },
    { no: 31, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.CreateDemandSignalRequest
 */
export const CreateDemandSignalRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateDemandSignalRequest",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "warehouse_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "qty", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "uom", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "need_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "probability", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "priority", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "source_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "constraints", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.ListDemandSignalsRequest
 */
export const ListDemandSignalsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListDemandSignalsRequest",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "warehouse_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "page", kind: "message", T: PageRequest },
  ],
);

/**
 * @generated from message omnios.v1.ListDemandSignalsResponse
 */
export const ListDemandSignalsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListDemandSignalsResponse",
  () => [
    { no: 1, name: "signals", kind: "message", T: DemandSignal, repeated: true },
    { no: 10, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.CancelDemandSignalRequest
 */
export const CancelDemandSignalRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CancelDemandSignalRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.Bom
 */
export const Bom = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.Bom",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "effective_from", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "effective_to", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "lines", kind: "message", T: BomLine, repeated: true },
    { no: 30, name: "created_at", kind: "message", T: Timestamp },
    { no: 31, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.BomLine
 */
export const BomLine = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BomLine",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "component_product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "quantity_per", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "uom", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "scrap_pct", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "operation_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "work_center_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "setup_time_min", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "run_time_per_unit_min", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 10, name: "operation_params", kind: "message", T: Struct },
    { no: 11, name: "sequence", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.CreateBomRequest
 */
export const CreateBomRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateBomRequest",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "effective_from", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "effective_to", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "lines", kind: "message", T: CreateBomLineRequest, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.CreateBomLineRequest
 */
export const CreateBomLineRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateBomLineRequest",
  () => [
    { no: 1, name: "component_product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "quantity_per", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "uom", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "scrap_pct", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "operation_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "work_center_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "setup_time_min", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 8, name: "run_time_per_unit_min", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "operation_params", kind: "message", T: Struct },
    { no: 10, name: "sequence", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.GetBomRequest
 */
export const GetBomRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetBomRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListBomsRequest
 */
export const ListBomsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListBomsRequest",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "page", kind: "message", T: PageRequest },
  ],
);

/**
 * @generated from message omnios.v1.ListBomsResponse
 */
export const ListBomsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListBomsResponse",
  () => [
    { no: 1, name: "boms", kind: "message", T: Bom, repeated: true },
    { no: 10, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.WorkCenter
 */
export const WorkCenter = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.WorkCenter",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "capacity_hours_per_day", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "cost_per_hour", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "efficiency_pct", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "attributes", kind: "message", T: Struct },
    { no: 8, name: "active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 30, name: "created_at", kind: "message", T: Timestamp },
    { no: 31, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.PlannedAction
 */
export const PlannedAction = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PlannedAction",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "plan_run_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "action_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "warehouse_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "qty", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "uom", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "target_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "order_by_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "urgency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "supplier_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "estimated_cost_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 13, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "confidence", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 15, name: "reason_signal_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 16, name: "alternatives", kind: "message", T: Struct },
    { no: 17, name: "optimization_result", kind: "message", T: Struct },
    { no: 18, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 19, name: "approved_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "approved_at", kind: "message", T: Timestamp },
    { no: 21, name: "executed_order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 30, name: "created_at", kind: "message", T: Timestamp },
    { no: 31, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.ListPlannedActionsRequest
 */
export const ListPlannedActionsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListPlannedActionsRequest",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "urgency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "page", kind: "message", T: PageRequest },
  ],
);

/**
 * @generated from message omnios.v1.ListPlannedActionsResponse
 */
export const ListPlannedActionsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListPlannedActionsResponse",
  () => [
    { no: 1, name: "actions", kind: "message", T: PlannedAction, repeated: true },
    { no: 10, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.ApprovePlannedActionRequest
 */
export const ApprovePlannedActionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ApprovePlannedActionRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ProductionOrder
 */
export const ProductionOrder = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ProductionOrder",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "bom_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "quantity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "uom", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "planned_start", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "planned_end", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "actual_start", kind: "message", T: Timestamp },
    { no: 10, name: "actual_end", kind: "message", T: Timestamp },
    { no: 11, name: "work_center_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "priority", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 13, name: "production_params", kind: "message", T: Struct },
    { no: 14, name: "yield_qty", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 15, name: "scrap_qty", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 30, name: "created_at", kind: "message", T: Timestamp },
    { no: 31, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.CreateProductionOrderRequest
 */
export const CreateProductionOrderRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateProductionOrderRequest",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "bom_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "quantity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "uom", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "planned_start", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "planned_end", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "work_center_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "priority", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "production_params", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.ReleaseProductionOrderRequest
 */
export const ReleaseProductionOrderRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ReleaseProductionOrderRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.StartProductionOrderRequest
 */
export const StartProductionOrderRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.StartProductionOrderRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CompleteProductionOrderRequest
 */
export const CompleteProductionOrderRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CompleteProductionOrderRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "yield_qty", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "scrap_qty", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message omnios.v1.ForecastRequest
 */
export const ForecastRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ForecastRequest",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "warehouse_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "periods", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.ForecastResponse
 */
export const ForecastResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ForecastResponse",
  () => [
    { no: 1, name: "points", kind: "message", T: ForecastPoint, repeated: true },
    { no: 2, name: "model_used", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "pattern", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ForecastPoint
 */
export const ForecastPoint = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ForecastPoint",
  () => [
    { no: 1, name: "period", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "forecast", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "lower", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "upper", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message omnios.v1.ReplanRequest
 */
export const ReplanRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ReplanRequest",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "warehouse_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ReplanResponse
 */
export const ReplanResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ReplanResponse",
  () => [
    { no: 1, name: "new_actions", kind: "message", T: PlannedAction, repeated: true },
    { no: 2, name: "cancelled_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.SimulateRequest
 */
export const SimulateRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SimulateRequest",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "warehouse_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "demand_multiplier", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "lead_time_multiplier", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "supply_disruption_pct", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "horizon_days", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "monte_carlo_samples", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.SimulateResponse
 */
export const SimulateResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SimulateResponse",
  () => [
    { no: 1, name: "service_level", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "avg_inventory", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "stockout_probability", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "total_cost", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "safety_stock_recommendation", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "scenarios_run", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "suggested_actions", kind: "message", T: PlannedAction, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.PlanningException
 */
export const PlanningException = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PlanningException",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "exception_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "severity", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "warehouse_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "details", kind: "message", T: Struct },
    { no: 8, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "resolved_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "resolved_at", kind: "message", T: Timestamp },
    { no: 30, name: "created_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.ListExceptionsRequest
 */
export const ListExceptionsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListExceptionsRequest",
  () => [
    { no: 1, name: "severity", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "page", kind: "message", T: PageRequest },
  ],
);

/**
 * @generated from message omnios.v1.ListExceptionsResponse
 */
export const ListExceptionsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListExceptionsResponse",
  () => [
    { no: 1, name: "exceptions", kind: "message", T: PlanningException, repeated: true },
    { no: 10, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.AcknowledgeExceptionRequest
 */
export const AcknowledgeExceptionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AcknowledgeExceptionRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ResolveExceptionRequest
 */
export const ResolveExceptionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ResolveExceptionRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "resolution_note", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.SupplyNode
 */
export const SupplyNode = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SupplyNode",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "node_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "lat", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "lng", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "holding_cost_per_unit_day", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 30, name: "created_at", kind: "message", T: Timestamp },
    { no: 31, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.SupplyEdge
 */
export const SupplyEdge = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SupplyEdge",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "from_node_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "to_node_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "edge_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "lead_time_distribution", kind: "message", T: Struct },
    { no: 6, name: "cost_per_unit", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "min_order_qty", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 8, name: "max_order_qty", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "transport_mode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "correlation", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 30, name: "created_at", kind: "message", T: Timestamp },
    { no: 31, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.CreateSupplyNodeRequest
 */
export const CreateSupplyNodeRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateSupplyNodeRequest",
  () => [
    { no: 1, name: "node_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "lat", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "lng", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "holding_cost_per_unit_day", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message omnios.v1.CreateSupplyEdgeRequest
 */
export const CreateSupplyEdgeRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateSupplyEdgeRequest",
  () => [
    { no: 1, name: "from_node_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "to_node_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "edge_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "lead_time_distribution", kind: "message", T: Struct },
    { no: 5, name: "cost_per_unit", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "min_order_qty", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "max_order_qty", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 8, name: "transport_mode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "correlation", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message omnios.v1.ListSupplyNodesRequest
 */
export const ListSupplyNodesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListSupplyNodesRequest",
  () => [
    { no: 1, name: "node_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "page", kind: "message", T: PageRequest },
  ],
);

/**
 * @generated from message omnios.v1.ListSupplyNodesResponse
 */
export const ListSupplyNodesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListSupplyNodesResponse",
  () => [
    { no: 1, name: "nodes", kind: "message", T: SupplyNode, repeated: true },
    { no: 10, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.SubstitutionRule
 */
export const SubstitutionRule = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SubstitutionRule",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "from_product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "to_product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "direction", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "conditions", kind: "message", T: Struct },
    { no: 6, name: "price_adjustment_pct", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "plugin_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 30, name: "created_at", kind: "message", T: Timestamp },
    { no: 31, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.CtpRequest
 */
export const CtpRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CtpRequest",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "qty", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "requested_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "priority", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "warehouse_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CtpResponse
 */
export const CtpResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CtpResponse",
  () => [
    { no: 1, name: "feasible", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "earliest_delivery_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "confirmed_qty", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "partial_qty", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "partial_available_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "constraint_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "production_required", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "production_days", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "material_availability_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "capacity_slots", kind: "message", T: CapacitySlot, repeated: true },
    { no: 11, name: "cost_estimate", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 12, name: "explanation", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CapacitySlot
 */
export const CapacitySlot = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CapacitySlot",
  () => [
    { no: 1, name: "work_center_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "start_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "end_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "allocated_hours", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message omnios.v1.SopDemandPlanRequest
 */
export const SopDemandPlanRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SopDemandPlanRequest",
  () => [
    { no: 1, name: "family_product_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "family_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "horizon_months", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.SopDemandPlanResponse
 */
export const SopDemandPlanResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SopDemandPlanResponse",
  () => [
    { no: 1, name: "family_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "buckets", kind: "message", T: SopMonthlyBucket, repeated: true },
    { no: 3, name: "total_demand", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "total_revenue", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message omnios.v1.SopMonthlyBucket
 */
export const SopMonthlyBucket = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SopMonthlyBucket",
  () => [
    { no: 1, name: "year", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "month", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "demand_qty", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "demand_revenue", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "supply_qty", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "production_qty", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "inventory_qty", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message omnios.v1.SopRccpRequest
 */
export const SopRccpRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SopRccpRequest",
  () => [
    { no: 1, name: "production_plan", kind: "message", T: SopMonthlyBucket, repeated: true },
    { no: 2, name: "family_product_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "horizon_months", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.SopRccpResponse
 */
export const SopRccpResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SopRccpResponse",
  () => [
    { no: 1, name: "work_centers", kind: "message", T: SopWorkCenterLoad, repeated: true },
    { no: 2, name: "gaps", kind: "message", T: SopGap, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.SopWorkCenterLoad
 */
export const SopWorkCenterLoad = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SopWorkCenterLoad",
  () => [
    { no: 1, name: "work_center_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "monthly_load_hours", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, repeated: true },
    { no: 4, name: "monthly_capacity_hours", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, repeated: true },
    { no: 5, name: "utilization_pct", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, repeated: true },
    { no: 6, name: "overloaded_months", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.SopGap
 */
export const SopGap = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SopGap",
  () => [
    { no: 1, name: "year", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "month", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "gap_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "qty", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.SopFinancialRequest
 */
export const SopFinancialRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SopFinancialRequest",
  () => [
    { no: 1, name: "supply_plan", kind: "message", T: SopMonthlyBucket, repeated: true },
    { no: 2, name: "unit_revenue", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "unit_cogs", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "holding_cost_pct", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message omnios.v1.SopFinancialResponse
 */
export const SopFinancialResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SopFinancialResponse",
  () => [
    { no: 1, name: "revenue", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, repeated: true },
    { no: 2, name: "cogs", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, repeated: true },
    { no: 3, name: "gross_profit", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, repeated: true },
    { no: 4, name: "inventory_carrying_cost", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, repeated: true },
    { no: 5, name: "working_capital", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.CancelPlannedActionRequest
 */
export const CancelPlannedActionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CancelPlannedActionRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListProductionOrdersRequest
 */
export const ListProductionOrdersRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListProductionOrdersRequest",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "work_center_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "page", kind: "message", T: PageRequest },
  ],
);

/**
 * @generated from message omnios.v1.ListProductionOrdersResponse
 */
export const ListProductionOrdersResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListProductionOrdersResponse",
  () => [
    { no: 1, name: "orders", kind: "message", T: ProductionOrder, repeated: true },
    { no: 10, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.CancelProductionOrderRequest
 */
export const CancelProductionOrderRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CancelProductionOrderRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.DismissExceptionRequest
 */
export const DismissExceptionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DismissExceptionRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetDemandSignalRequest
 */
export const GetDemandSignalRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetDemandSignalRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetPlannedActionRequest
 */
export const GetPlannedActionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetPlannedActionRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CommitSopPlanRequest
 */
export const CommitSopPlanRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CommitSopPlanRequest",
  () => [
    { no: 1, name: "family_product_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "family_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "production_plan", kind: "message", T: SopMonthlyBucket, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.CommitSopPlanResponse
 */
export const CommitSopPlanResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CommitSopPlanResponse",
  () => [
    { no: 1, name: "signals_created", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "product_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

